import React from 'react';
import styles from './styles.module.css';
import parts from '../moduleCard/moduleParts.module.css';
import BodyOverview from './BodyOverview';
import { EXAMPLE_CURRENT, EXAMPLE_HISTORY, EXAMPLE_REFERENCE } from './bodyMeasurementsExample';

/**
 * Estado vazio do módulo: a visão geral esmaecida com valores ilustrativos e
 * a etiqueta "Exemplo", para o profissional ver o que ganha ao registrar a
 * primeira avaliação. Nada aqui é clicável.
 */
const BodyExampleOverview = ({ variant }) => (
  <div className={styles.example} aria-label="Exemplo de visão geral, sem dados do paciente">
    <div className={styles.exampleHead}>
      <span className={`${parts.chip} ${parts.chipAccent}`}>Exemplo</span>
      <span className={parts.muted}>
        Nenhuma avaliação registrada. Assim fica a visão geral depois da primeira: os valores abaixo são ilustrativos.
      </span>
    </div>
    <div className={styles.exampleBody} aria-hidden="true">
      <BodyOverview history={EXAMPLE_HISTORY} current={EXAMPLE_CURRENT} reference={EXAMPLE_REFERENCE} variant={variant} />
    </div>
  </div>
);

export default BodyExampleOverview;
